export default (palette) => ({
  root: {
    // Vinculação oficial ao Single Source of Truth da paleta! 🧼🚀🌓
    backgroundColor: palette.backGroundItem?.tabelaHeaderFooter, 
    '& .MuiTableRow-root': {
      backgroundColor: 'transparent !important', // Impede que herde o fundo sólido do Body 🛡️✨
    },
    '& .MuiTableCell-root': {
      backgroundColor: 'transparent !important', // Garante transparência absoluta das células de header 🛡️✨
    },
  },
})
